export default "__VITE_ASSET__DCKAMuL1__"